<template>
    <div class="echart-info">
        <div  class="echart-box" ref="echart_pie"> </div>
        <el-table
            ref='tableList'
            :header-cell-style="{background:'#409EFF',color:'#fff'}"
            size='mini'
            :data="echartList"
            border>
                <el-table-column
                    label="NO" 
                    align="center" 
                    prop="num"
                    width='140'
                >
                </el-table-column>
                <el-table-column
                    align="center" 
                    prop="valueName"
                    :label="chartName">
                </el-table-column>
                <el-table-column
                    align="center" 
                    prop="valueName"
                    label="频次">
                </el-table-column>
                <el-table-column
                    align="center" 
                    prop="percentage"
                    label="百分比">
                </el-table-column>
        </el-table>
    </div>
</template>

<script>
import subjectData from './subjectData.js';
import subjectJson from './subjectJson.js'
export default {
    props: ['chartName','echartList'],
    data () {
        return {
            // echartList:subjectData.echartList,
            myChartPie:'',
            echartLoad:false,
            legend_data:[],
            series_data:[],
            modelData:[], 
            opts :{
                type: 'jpeg', // 导出的格式，可选 png, jpeg
                pixelRatio: 1,// 导出的图片分辨率比例，默认为 1。
                backgroundColor: "#fff",// 导出的图片背景色，默认使用 option 里的 backgroundColor
                // excludeComponents: Array.<string>  // 忽略组件的列表，例如要忽略 toolbox 就是 ['toolbox'],一般也忽略了'toolbox'这栏就够了
            },
            reportImg:'',//图标的url
            // 报名文件名称
            reportName:'', 
            tooltip: {
                trigger: "item",
                backgroundColor: "rgba(0,0,0,0.8)",
                borderColor: '#333',
                textStyle: {
                    color:'#fff'
                }
            },
            toolbox: {
                show: true,
                feature: {
                    saveAsImage: {
                        title: '保存为图片',
                        show: true
                    }
                },
            },
            splitLine: {
                show: false
            },
            axisLine: {
                show: false
            },
        }
    }, 
    watch: {
        echartList(val,old){ 
            if(val&&val!=old){
                this.getChartList()
            }
        }  
    },
    mounted() { 
        this.myChartPie = this.$echarts.init(this.$refs.echart_pie,'dark');
        this.echartLoad=true;  
        // this.echartList=[];
        this.getChartList();
        
    },
    methods: {
        getChartList() { 
            // this.echartList=subjectData.echartList; 
            this.legend_data=[];
            this.series_data=[]; 
            this.echartList&&this.echartList.forEach((item,index) => {
                this.legend_data.push(item.keyName);
                item.num=index+1;
                let obj = {
                    value:item.valueName,
                    // name:item.keyName,
                    name:item.keyName+`(${item.valueName}次)`,
                }
                // 2025.02.24 频次为0不展示
                if(item.valueName!=0){
                   this.series_data.push(obj)
                }
                
            });
            this.setEcharts_pie()
        },
        //饼图
        setEcharts_pie(){
            let chartOption ={
                title: {
                    text:this.chartName+'分布图',
                    left: 'center'
                },
                tooltip: this.tooltip,
                toolbox: this.toolbox,
                // legend: {
                //     type: 'scroll',
                //     bottom: 'bottom',
                //     data: this.legend_data,
                //     selected:this.legend_data


                // }, 
                series: [{
                    animation:false,
                    name: '频次',
                    type: 'pie',
                    radius: '50%',
                    center: ['50%', '50%'],
                    data: this.series_data,
                    label: {
                        normal: {
                            // show: true,
                            // formatter: '{b}({d}%)' //自定义显示格式(b:name, c:value, d:百分比)
                            textStyle:{
                                fontSize:this.lableNum
                            }
                        },
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                            
                        }
                    }
                }],
            };
            this.myChartPie.setOption(chartOption);
            this.reportImg  =this.myChartPie.getDataURL(this.opts) 

        },
    }
}
</script>

<style lang="less" scoped>
.echart-box{
    width: 100%;
    height: 500px;
}
</style>